import React from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import MySelect from '../Select'
import SimpleBlockContent from '../../../SimpleBlockContent'

function SelectField({ labelText, value, options, description, onChange }) {
  return (
    <div className={styles.inputWrapper}>
      <label>
        <Text type="caption-1">{labelText}</Text>
      </label>
      <MySelect
        value={value}
        options={options}
        onChange={onChange}
      />
      <SimpleBlockContent blocks={description}/>
    </div>
  )
}

export default SelectField
